import GetUserToken from "../utils/GetUserToken";
import { parseJSON } from "../utils/parseJSON";

const urlBase = `${process.env.REACT_APP_API_URL_V2}/blends`;
const readUrl = (url = "") => `${urlBase}/${url}`;

class Blend {
  async getOne({ id }) {
    console.log("getOne - blends - service", id);
    const auth = `${GetUserToken()}`;

    let res = await fetch(readUrl(id), {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
      },
    });

    res = await parseJSON(res);
    return res;
  }

  async getAll(payload) {
    console.log("payload", payload);
    console.log("getAll - blends - service");
    const auth = `${GetUserToken()}`;
    const { currentPage, sortBy, sortDirection, itemsPerPage, filters } =
      payload;
    const queryParams = new URLSearchParams(filters).toString();

    let res = await fetch(
      `${readUrl()}?${queryParams}&currentPage=${currentPage}&sortBy=${sortBy}&sortDirection=${sortDirection}&itemsPerPage=${itemsPerPage}`,
      {
        method: "GET",
        headers: {
          Authorization: auth,
          "Content-Type": "application/json",
          "api-key": process.env.REACT_APP_API_KEY,
        },
      }
    );

    res = await parseJSON(res);
    return res;
  }

  async createOne(payload) {
    console.log("createOne - blends - service", payload);

    const auth = `${GetUserToken()}`;

    let res = await fetch(readUrl(), {
      method: "POST",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(payload),
    });

    res = await parseJSON(res);
    return res;
  }

  async update(payload) {
    const { id, ...rest } = payload;
    console.log("update - blends - service", payload);

    const auth = `${GetUserToken()}`;

    let res = await fetch(readUrl(id), {
      method: "PATCH",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify(rest),
    });

    res = await parseJSON(res);
    return res;
  }
}

const blend = new Blend();
export default blend;
